import React from 'react'
import { FormattedMessage } from 'react-intl'
//import projectImage1 from '../assets/images/results-project1.jpg'
import projectImage2 from '../assets/images/results-project-new-1@2x.jpg'
import projectImage3 from '../assets/images/results-project-new-2@2x.jpg'

export const ResultsProjects = () => {
  const generateProjects = () => {
    // generate array of project images
    const projectImages = [
      //projectImage1,
      projectImage2,
      projectImage3
    ]
  
    return projectImages.map((image, index) => (
      <div
        className="ciicc-results-project"
        key={`results-project-${index}`}
      >
        <img src={image} alt="" className="mb-20" />
        <h3 className="text-header-primary-color semibold font-24 mb-20">
          <FormattedMessage
            id={`results.how.project${index + 2}.title`}
          />
        </h3>
        <p className="font-16">
          <FormattedMessage
            id={`results.how.project${index + 2}.copy`}
          />
        </p>
      </div>
    ))
  }
  
  return (
    <section className="ciicc-section">
      <div className="ciicc-wrap -narrow">
        <div>
          <h2 className="text-header-primary-color semibold font-32 mb-20">
            <FormattedMessage id="results.how.title" />
          </h2>
          <p className="mb-40">
            <FormattedMessage id="results.how.copy" />   
          </p>
        </div>
        <div className="ciicc-results-projects">
          {generateProjects()}
        </div>
      </div>
    </section>
  )
}